/** The server's data on a push: what it is about and the screen it opens. */
export interface PushData {
  type?: string;
  callId?: string;
  url?: string;
}

/**
 * Hear a web push that arrives while the page is open. public/sw.js shows
 * the notification and posts its data to every open page as
 * `push-received`. Returns the unsubscribe.
 *
 * A wrapper's pushes come through OneSignal, which tells the page only of a
 * tap (`navigate`, docs/native-bridge.md), so in a wrapper this hears
 * nothing and the page learns of the push when it is tapped.
 */
export function onPushReceived(handler: (data: PushData) => void): () => void {
  const worker =
    typeof navigator === 'undefined' ? undefined : navigator.serviceWorker;
  if (!worker?.addEventListener) return () => {};
  const listener = (event: MessageEvent) => {
    if (event.data?.type === 'push-received') handler(event.data.data ?? {});
  };
  worker.addEventListener('message', listener);
  return () => worker.removeEventListener('message', listener);
}
